document.addEventListener('DOMContentLoaded', () => {

    /* Show/hide more info */

    const showHideMore = () => {
        const switcher = document.querySelector('.js-more-info-trigger');
        const moreInfContent = document.querySelector('.js-more-info');
        switcher.addEventListener('click', function (e) {
            e.currentTarget.classList.toggle('hide');
            moreInfContent.classList.toggle('show');
        });
    }

    /* Add hidden name property */

    const addPropertyValue = () => {
        const topicInputs = document.querySelectorAll('.property-name-js');

        if (topicInputs) {
            topicInputs.forEach(el => {
                let parentForm = el.closest('.c-form-basic');
                if (parentForm) {
                    let dataTopic = parentForm.getAttribute('data-property');
                    if (dataTopic) el.value = dataTopic;
                }
            });
        }
    }

    /* slider settings for popups */
    
    const sliderPopupGalery = () => {

        const slidersPropertyImages = document.querySelectorAll('.js-slider-all-porpety-images');
        const settVisibleSlide = document.querySelectorAll('.js-set-view-slide');

        if (slidersPropertyImages) {
            slidersPropertyImages.forEach((box) => {
                if (box) {
                    const arrLeft = box.querySelector('.swiper-button-prev-custom');
                    const arrRight = box.querySelector('.swiper-button-next-custom');
                    let currentSlideIndex = 0;

                    let newSwiper = new Swiper(box, {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        slideToClickedSlide: true,
                        centeredSlides: true,
                        loop: true,
                        preloadImages: false,
                        initialSlide: 0,
                        lazy: true,
                        observer: true,
                        effect: 'slide',
                        speed: 800,
                        autoHeight: true,
                        pagination: false,
                        autoplay: false,
                        navigation: {
                            nextEl: arrRight,
                            prevEl: arrLeft,
                        },
                        breakpoints: {
                            576: {
                                pagination: false,
                            },
                        }
                    });

                    arrLeft.addEventListener('click', function() {
                        let newIndex = parseInt(currentSlideIndex) - 1;
                        if(newIndex === -1) newIndex = parseInt(newSwiper.slides.length) - 2;
                        newSwiper.slideTo(newIndex);
                        currentSlideIndex = newIndex;
                      });

                    arrRight.addEventListener('click', function() {
                        console.log(currentSlideIndex );
                        let newIndex = parseInt(currentSlideIndex) + 1;
                        if(newIndex > (newSwiper.slides.length - 2)) newIndex = 1;
                        newSwiper.slideTo(newIndex);
                        currentSlideIndex = newIndex ;
                      });

                    if(settVisibleSlide){
                        settVisibleSlide.forEach(el =>{
                            el.addEventListener("click",(e)=>{
                                const slideKey = e.currentTarget.getAttribute('data-slideKey');
                                if(slideKey && slideKey <= (parseInt(newSwiper.slides.length) - 2) ) {
                                    currentSlideIndex = slideKey;
                                    newSwiper.slideTo(slideKey);
                                }
                            });
                        });
                    }

                }
            });
        }
    }

    //all functions
    showHideMore();
    addPropertyValue();
    sliderPopupGalery()
});

/* Add scroll to bottom on first section property */

const scrollToElemCustom = (top) => {

    window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
    });


    isAnimating = true;
    setTimeout(() => {
        isAnimating = false;
    }, 400);
}

//checked elem visible
const isScrolledIntoView = (el, distancePageY) => {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top + window.pageYOffset;
    var elemBottom = rect.bottom + window.pageYOffset;
    var isVisible = (elemTop <= distancePageY) && (elemBottom >= distancePageY);

    return isVisible;
}

const firstSe = document.querySelector('.js-scroll-first-se');
const targetSe = document.querySelector('.js-target-last');

let isAnimating = false;
let self = this;
self._lastScroll = 0;
let scrollStopTime = 600;
if ((navigator.appVersion.indexOf('Mac') != -1) || navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) scrollStopTime = 1000;

const scrollFirstSection = (e) => {
    self._thisScroll = new Date().getTime();

    if ((self._thisScroll - self._lastScroll) > scrollStopTime) {

        let distancePageY = e.pageY;
        if (isScrolledIntoView(firstSe, distancePageY) && !isAnimating) {
            if (e.deltaY > 0) {
                e.preventDefault();
                e.stopPropagation();
                let topTarget = targetSe.offsetTop
                scrollToElemCustom(topTarget);
            }
        }
        self._lastScroll = new Date().getTime();
    } else {
        e.preventDefault();
        e.stopPropagation();
    }
}

if (firstSe) {
    window.__forceSmoothScrollPolyfill__ = true;
    firstSe.addEventListener('wheel', scrollFirstSection, {
        capture: true,
        passive: false,
    });
}